export default __webpack_public_path__ + "src/icons/state.svg";